import theme from "../../theme/theme"

export const BUTTON_SIZES = {
    sm: {
        height: 28,
        fontSize: theme.typography.fontSizes.sm,
        padding: "8px 14px",
    },
    md: {
        height: 40,
        fontSize: theme.typography.fontSizes.sm,
        padding: "8px 16px 8px 14px",
    },
    lg: {
        height: 40,
        fontSize: theme.typography.fontSizes.base,
        padding: "8px 16px 8px 14px",
    },
}
